import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Form from 'root/module/form';
import Modal from 'root/module/modal';
import View from 'root/view/base';
import Model_Integration_Webhook from 'root/model/integration_webhook';

var Webhook_Edit = View.extend({
    add_new    : false,
    url_upgrade: false,
    webhook_url: '',
    event_type : [],

    events: {
        'input input[name="webhook_url"]'   : 'onInputUrl',
        'click input[name="event_type"]'    : 'onToggleWebhookEvent',
        'click .account-upgrade'            : 'onUpgrade',
        'submit form'                       : 'onSubmit'
    },

    dom_handlers: {
        onInputUrl: function () {
            this.webhook_url = Form.getData(this.$el.find('form')).webhook_url;

            this.renderButton();
        },

        onToggleWebhookEvent: function() {
            this.event_type = Form.getData(this.$el.find('form')).event_type;

            this.renderButton();
        },

        onUpgrade: function () {
            var data = Form.getData(this.$el.find('form'));
            var event_type = [Constants.WEBHOOK_EVENT_FEEDBACK_ADD];

            Modal.confirm('<p>Are you sure you want to upgrade your webhook integration? Your existing webhook integration will need to be <a href="https://support.userback.io/en/articles/5209230-advanced-webhooks-in-userback" target="_help" rel="noopener">updated</a> to work with the new event payload.</p>', function() {
                this.$el.find('.account-upgrade').addClass('loading');

                Cache.app.request({
                    action : 'integration/update',
                    data   : {
                        type       : 'webhook',
                        webhook_url: data.webhook_url,
                        event_type : event_type,
                    },

                    success: (response) => {
                        UI.success('Webhook integration updated');

                        this.model.set(response.data);

                        this.trigger('submit:success');
                    },
                    complete: () => {
                        this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');
                    }
                });

            }, this, 'Yes, update');
        },

        onSubmit: function() {
            var data = Form.getData(this.$el.find('form'));
            var event_type = data.event_type;

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action : this.add_new ? 'integration/activate': 'integration/update',
                data   : {
                    type       : 'webhook',
                    webhook_url: data.webhook_url,
                    event_type : event_type,
                },

                success: (response) => {
                    this.model.set(response.data);

                    if (this.add_new) {
                        Cache.integration_webhook.add(this.model);
                        UI.success('Webhook integration activated');
                        Cache.app.trackEvent('Integration Added', { integration: 'Webhook' });
                    } else {
                        UI.success('Webhook integration updated');
                    }

                    this.trigger('submit:success');
                },
                complete: () => {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');
                }
            });
        }
    },

    initialize: function (options) {
        this.model = Cache.integration_webhook.findWhere({project_id: Cache.default_project_id}) || new Model_Integration_Webhook({
            account_id: Cache.account.get('id'),
            project_id: Cache.default_project_id
        });

        this.add_new = !!options.add_new;
        this.webhook_url = this.model.get('webhook_url') || '';
        this.event_type  = this.model.get('event_type');
        this.url_upgrade = this.webhook_url && this.event_type.length === 1 && this.event_type[0] === Constants.WEBHOOK_EVENT_FEEDBACK_ADD_OLD;
    },

    renderButton: function() {
        var submit_btn = this.$el.find('button[type="submit"]');
        var disabled   = false;

        if (this.url_upgrade) {
            disabled = !this.webhook_url;
        } else {
            disabled = !this.webhook_url || !this.event_type.length;
        }

        submit_btn.prop('disabled', disabled);
    },

    render: function() {
        var content =
        '<form class="form-fluid">' +
            '<div class="grid-4-8">' +
                '<div><h5>Webhook URL</h5></div>' +
                '<div class="row">' +
                    '<div class="field-label">Webhook URL</div>' +
                    '<input class="solid medium" type="url" name="webhook_url" placeholder="https://" required>' +
                    '<div class="text-info margin-top-8">' +
                        '<a class="text-info" href="https://docs.userback.io/docs/webhooks-overview" target="help" rel="noopener">Webhook documentation<i class="fa-regular fa-arrow-up-right-from-square margin-left-4 fa-xs"></i></a>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<hr>' +
            '<div class="grid-4-8">' +
                '<div><h5>Webhook Events</h5></div>' +
                '<div>' +
                    (Cache.getDefaultProject().isFeedback() ?

                    '<div class="row">' +
                        (
                            this.url_upgrade
                                ? '<div class="margin-bottom-16">' +
                                        '<div class="margin-bottom-8">In order to subscribe to the new webhook events, you\'ll need to upgrade your webhook integration. <a href="https://support.userback.io/en/articles/5209230-advanced-webhooks-in-userback" target="_help" rel="noopener">Click here to learn more</a>.</div>' +
                                        '<button class="primary tiny account-upgrade" type="button">Update</button>' +
                                    '</div>'
                                : ''
                        ) +
                        '<div class="field-label">Feedback</div>' +
                        '<div class="margin-bottom-16"' + (this.url_upgrade ? '' : 'hidden') + '>' +
                            '<input type="checkbox" name="event_type" id="event_type_0" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_ADD_OLD + '" disabled>' +
                            '<label for="event_type_0">New feedback is added</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16"' + (this.url_upgrade ? 'hidden' : '') + '>' +
                            '<input type="checkbox" name="event_type" id="event_type_1" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_ADD + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_1">New feedback is added</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_3" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_ASSIGN + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_3">Feedback is assigned</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_4" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_STATUS + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_4">Feedback status is changed</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_5" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_PRIORITY + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_5">Feedback priority is changed</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_6" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_VOTE + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_6">Feedback is voted</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_2" value="' + Constants.WEBHOOK_EVENT_FEEDBACK_DELETE + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_2">Feedback is deleted</label>' +
                        '</div>' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Comment</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_7" value="' + Constants.WEBHOOK_EVENT_COMMENT_ADD + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_7">New comment is added to a feedback</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_8" value="' + Constants.WEBHOOK_EVENT_COMMENT_EDIT + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_8">Comment is updated</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_10" value="' + Constants.WEBHOOK_EVENT_COMMENT_STATUS + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_10">Comment status is changed</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_9" value="' + Constants.WEBHOOK_EVENT_COMMENT_DELETE + '" ' + (this.url_upgrade ? 'disabled' : '') + '>' +
                            '<label for="event_type_9">Comment is deleted</label>' +
                        '</div>' +
                    '</div>' :

                    '<div class="row">' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_0" value="' + Constants.WEBHOOK_EVENT_SURVEY_RESPONSE_ADD + '">' +
                            '<label for="event_type_0">New survey response is received</label>' +
                        '</div>' +
                        '<div class="margin-bottom-16">' +
                            '<input type="checkbox" name="event_type" id="event_type_1" value="' + Constants.WEBHOOK_EVENT_SURVEY_RESPONSE_DELETE + '">' +
                            '<label for="event_type_1">Survey response is deleted</label>' +
                        '</div>' +
                    '</div>') +
                '</div>' +
            '</div>' +
            '<hr>' +
            '<div class="sidebar-bottom">' +
                '<button type="submit" class="primary" disabled>' + (this.add_new ? 'Complete Setup' : 'Save Changes') + '</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);
        this.renderButton();

        var event_type_value = this.url_upgrade ? [Constants.WEBHOOK_EVENT_FEEDBACK_ADD_OLD] : this.event_type;

        Form.setData(this.$el.find('form'), {
            webhook_url: this.webhook_url || '',
            event_type : event_type_value,
        });

        // Focus the input when animation is complete.
        setTimeout(() => {
            this.$el.find('input[name="webhook_url"]').first().trigger('focus');
        }, 160);

        return this;
    }
});

export default Webhook_Edit;